export default __webpack_public_path__ + "static/media/not-signed-in.0405d3c9.png";